import $ from 'jquery';
import GroupedContent from 'grouped-content';
import fitvids from 'fitvids';

export default class Rte {
  constructor({ el }) {
    this.$el = $(el);
    this.setupTabs();
    fitvids();
  }

  setupTabs() {
    this.groupedContent = new GroupedContent(this.$el.get(0), { layout: 'tabs', intelliparse: false });
  }
}
